import { CSSProperties } from 'react'
import styled from '@emotion/styled'
import StyledButton from '@organs/StyledButton'

export type FinalTestMethodOption = {
  value: 'manual' | 'xls' | 'scorm'
  label: string
}

export const finalTestMethodModalStyle: CSSProperties = {
  boxSizing: 'border-box',
  width: 'min(994px, calc(100vw - 32px))',
  maxWidth: 'calc(100vw - 32px)',
  minWidth: 0,
  minHeight: 216,
  borderRadius: 22,
  padding: '33px clamp(14px, 1.45vw, 20px) 34px clamp(14px, 2.5vw, 34px)',
}

export const FinalTestModalContent = styled.div`
  display: flex;
  min-height: 149px;
  flex-direction: column;
`

export const FinalTestModalTitle = styled.h3`
  margin: 0 36px 22px 0;
  color: #000;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;

  @media (max-width: 767px) {
    margin-bottom: 22px;
    font-size: 24px;
    line-height: 30px;
  }
`

export const FinalTestMethodList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const FinalTestMethodRadioLabel = styled.label<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 210px;
  min-height: 41px;
  gap: 9px;
  padding: 12px;
  border-radius: 10px;
  background: ${({ isActive }) => (isActive ? '#e8f1fb' : '#fafafa')};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #000;
  transition: background 0.2s ease;
  white-space: nowrap;

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  input:focus-visible + span {
    outline: 2px solid ${({ theme }) => theme.colors.main};
    outline-offset: 3px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const FinalTestMethodRadioMark = styled.span<{ isActive: boolean }>`
  position: relative;
  display: block;
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  box-sizing: border-box;
  border: 2px solid ${({ theme }) => theme.colors.main};
  border-radius: 50%;
  background: #fff;

  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.main};
    content: '';
    transform: translate(-50%, -50%);
  }
`

export const FinalTestModalActions = styled.div`
  margin-top: auto;
  padding-top: 17px;
  display: flex;
  justify-content: flex-end;
`

export const FinalTestSubmitButton = styled(StyledButton)`
  width: 105px;
  height: 41px;
  padding: 14px 19px;
  font-size: 12px;
  line-height: 13px;
  justify-content: center;
`
